import * as actions from './actions';

export const startHelp = () => ({
  type: actions.START_HELP
})

export const endHelp = () => ({
  type: actions.END_HELP
});

export const advanceHelp = () => ({
  type: actions.ADVANCE_HELP
})

export const backHelp = () => ({
  type: actions.BACK_HELP
})


// WEBPACK FOOTER //
// ./src/store/actions/help.js